import React, { CSSProperties, FC, useMemo } from 'react';
import classNames from 'classnames';
import { isUndefined } from '../../predicates/type';
import classes from './styles/movingGradient.module.scss';

export const MovingGradient: FC<
	React.PropsWithChildren<{
		className?: string;
		width?: string;
		height?: string;
		borderRadius?: string;
		style?: CSSProperties;
		/**
		 * The bigger number - the darker gradient (from 1 to 5)
		 */
		shade?: 1 | 2 | 3 | 4 | 5;
	}>
> = ({ children, className, width, height = '12px', borderRadius, shade = 1, style }) => {
	const componentClasses = classNames(classes[`movingGradient_shade${shade}`], classes.movingGradient, className);
	const styles = useMemo(() => {
		const computedStyles = isUndefined(style) ? {} : style;
		return {
			...computedStyles,
			width: typeof width === 'undefined' ? '100%' : width,
			height,
			borderRadius,
		};
	}, [style, width, height, borderRadius]);

	return (
		<div
			className={componentClasses}
			style={styles}
		>
			{children}
		</div>
	);
};
